import React from "react";

import SubBoxWrapper from "../../wrapper/SubBoxWrapper";

import ListItem from "./ListItem";

import NoItem from "../util/NoItem";

function Notice({ noticeList, info, titleText, noItemText, menuTypeCode, menuLink, callEmptyAlert, menuUrl, drawCd }) {
    return (
        <SubBoxWrapper
            info={info}
            titleText={titleText}
            menuLink={menuLink}
            menuTypeCode={menuTypeCode}
            customClassName={"notifiCation"}
            drawCd={drawCd}
        >
            {noticeList ? (
                noticeList.map((info, idx) => (
                    <ListItem
                        key={idx}
                        link={menuUrl}
                        category={info.NAME}
                        titleText={info.CNTT}
                        contentText={info.DTM}
                        callEmptyAlert={callEmptyAlert}
                        drawCd={drawCd}
                    />
                ))
            ) : (
                <NoItem titleText={noItemText} />
            )}
        </SubBoxWrapper>
    );
}

export default Notice;
